import { agent } from '../agent';
export class BaseInstrumentation {
    get agent() {
        return agent;
    }
}
//# sourceMappingURL=base.js.map